<template>
  <div class="mt-2">
    <div :class="[className, 'cursor-pointer select-none hover:underline']" @click="toggle()">
      {{ question }}
      <i v-if="showCaret" :class="['fas', isOpen ? 'fa-caret-up' : 'fa-caret-down']"/>
    </div>
    <div :class="['mt-2', !isOpen && 'hidden']">{{ answer }}</div>
  </div>
</template>

<script>
export default {
  props: {
    question: String,
    answer: String,
    className: {
      type: String,
      default: 'text-smurfs-gold',
    },
    showCaret: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
